var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fa-icon',{class:{ checked: !!_vm.v, unchecked: !_vm.v },attrs:{"icon":_vm.icon},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }